module.exports = __webpack_public_path__ + "media/images/app-forms-c0a3a8d61bc85f2f15c10ce19b0c1940.svg";